import { GlobalState } from '@leverege/ui-redux';
import { pathValue } from '@leverege/object-util';
import Err from '@leverege/error';
export default {
  id: 'recovr.key.ItemCreateHook',
  matches: {
    objectType: 'key'
  },
  hook: async (deviceData, props) => {
    const {
      data
    } = deviceData;
    const {
      delegate
    } = props;
    const locationId = delegate.match?.params?.locationId;
    const companyId = delegate.match?.params?.companyId;
    const keyId = pathValue(data, 'keyId');
    if (keyId && (locationId || companyId)) {
      const conditions = [{
        type: 'equals',
        field: 'data/keyId',
        value: keyId
      }];
      if (locationId) {
        conditions.push({
          type: 'equals',
          field: 'data/location/id',
          value: locationId
        });
      }
      if (companyId) {
        conditions.push({
          type: 'equals',
          field: 'data/company/id',
          value: companyId
        });
      }
      const {
        count
      } = await GlobalState.dispatch(delegate.search({
        filter: {
          type: 'logical',
          operator: 'and',
          conditions
        },
        limit: 1,
        queryName: 'itemCreateHook.key'
      }));
      if (count > 0) {
        throw Err.badRequest(`Key with keyId ${keyId} already exists`);
      }
    }
    return deviceData;
  }
};